module.exports = __webpack_public_path__ + "static/img/2.10692b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/sp/2.png
// module id = CU6O
// module chunks = 0